import { render, staticRenderFns } from "./InvoiceableTaskPriceRuleWrapper.vue?vue&type=template&id=581587b0&scoped=true&"
import script from "./InvoiceableTaskPriceRuleWrapper.vue?vue&type=script&lang=js&"
export * from "./InvoiceableTaskPriceRuleWrapper.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceableTaskPriceRuleWrapper.vue?vue&type=style&index=0&id=581587b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581587b0",
  null
  
)

export default component.exports